import { AxiosInstance, AxiosRequestConfig, AxiosResponse } from "axios"

import { ResponseData } from "../common"

export interface SearchCollectionPropertyPayload {
  favouriteListId: string | number | null
  date?: string
  guestCount: number
  numberOfdays?: number
  petAllowed: number
}

export interface SearchCollectionPropertiesRequest
  extends Partial<AxiosRequestConfig> {
  params: Record<string, string | number>
}

export interface SearchCollectionPropertyImage {
  isQRDetected: boolean
  file_description: string
  file_url: string
  pmc_id: string
  unit_d: string
  image_order: number
  photo_id: string | null
  pms_photo_id: string | null
  file_name: string
  is_cover_img: boolean
  upload_status: string
  height: number
  width: number
  is_hide: boolean
  is_video: boolean
  image_full_url: string
  alt_text: string | null
}

export interface SearchCollectionPropertyBadge {
  preferredHostBadge: boolean
  guestsRaveBadge: boolean
  whimstayGemBadge: boolean
}

export interface SearchCollectionProperty {
  propertyName: string
  propertySubTypeDesc: string
  propertyTypeDesc: string
  city: string
  state: string
  country: string
  latitude: number
  longitude: number
  minPrice: number
  maxPrice: number
  averagePrice: number
  noOfGuest: number
  noOfBedroom: number
  noOfBathroom: number
  kitchen: boolean
  wifi: boolean
  petsAllowd: boolean
  propertyStarSum: number
  propertyRatingUserCount: number
  active: boolean
  images: SearchCollectionPropertyImage[]
  oldPropertyId: string
  checkInDate: string
  checkOutDate: string
  noOfNights: number
  noOfBeds: number
  totalBeforeTaxes: number
  taxes: number
  discount: number
  originalTotalBeforeTaxes: number
  cleaningAndOwnerFees: number
  serviceFee: number
  createdDt: number
  postalCode: string
  postalName: string
  perNightSavedPercent: number
  totalSavedPercent: number
  landingPageClickTrackerUrl: string | null
  impressionTrackerUrl: string | null
  multiUnitGrp: string | null
  multiUnitSubGrp: string | null
  multiUnitCount: number
  minimumAgeLimit: number | null
  propertyScoresWithoutDates: number | null
  propertyScoresWithDates: number
  propertyScoresWithoutDatesV1: number | null
  propertyScoresWithDatesV1: number | null
  preferredHostBadge: boolean
  propertyBadge: SearchCollectionPropertyBadge
  stagePaymentTeaserAmount: number | null
  isPropertyLowSaving: boolean
  slug: string
  _id: string
  pmc_id: string
  pms_unit_id: string
  host_fee: number
  totalNightsRent: number
  taUpliftFee: number
  suitable_child: boolean
  multi_unit_grps: string | null
  isPriceDrop: boolean
  lowestPrice: number
  isPVIHike: boolean
  whimstaySaveAmount: number | null
  otaName: string | null
  count: number
  displayRecentlyAdded: boolean
  adultsCount: number | null
  childrenCount: number | null
  muUnitNumber: number
}

export interface SearchCollectionPropertiesContent {
  content: SearchCollectionProperty[]
  isPDAEnabled: boolean | null
  mapMarkerFitToView: boolean
  nearbyProperties: SearchCollectionProperty[] | null
  priceDropAlertId: string | number | null
  propertyCount: number
  showPDAToggle: boolean
  taUpliftCondition: number
  taUpliftMultiplier: number
}

export interface SearchCollectionPropertiesResponseData extends ResponseData {
  data?: SearchCollectionPropertiesContent
}

export interface SearchCollectionPropertiesResponse extends AxiosResponse {
  data: SearchCollectionPropertiesResponseData
}

export function searchCollectionPropertiesApi(
  {
    params,
    method = "get",
    url = "/user/favouritelist/ssc/collection/search",
    ...config
  }: SearchCollectionPropertiesRequest,
  axiosInstance: AxiosInstance,
): Promise<SearchCollectionPropertiesResponse> {
  return axiosInstance({
    params,
    method,
    url,
    ...config,
  }) as Promise<SearchCollectionPropertiesResponse>
}
